import type { SavedFilterType } from './types';

/**
 * Query key factory for saved-filter API queries.
 */
export const queryKeysSavedFilter = {
  base: () => 'savedFilter' as const,
  getAll: (type: SavedFilterType) =>
    [queryKeysSavedFilter.base(), 'list', { type }] as const,
} as const;
